<template>
  <div class="app-mobile-block">

    <div class="page-content-state">
      <span class="page-content-state__icon fal fa-desktop"></span>
      <div class="page-content-state__header">Sorry, the {{ __("label:home title") }} is optimised for use on tablet and desktop devices only.</div>
      <div class="page-content-state__content">
        <p>Planning your course can be a complicated task and we recommend you use a larger device.</p>
        <p>We are looking at providing a better mobile experience in future releases.</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MobileBlockScreen',
  data() {
    return {}
  },
  methods: {
    // __:i18n,
  }
}
</script>

